import Facebook from "../assets/social-media-icons/facebook_32x32.png";
import Twitter from "../assets/social-media-icons/twitter_32x32.png";
import Email from "../assets/social-media-icons/email_32x32.png";
import {Box, Button, Flex, Image, Link, Spacer, HStack} from '@chakra-ui/react';

const SocialMediaIcons = () => {
  return (
    <div className="flex justify-center md:justify-start my-10 gap-10">
      
      <Flex>
        <HStack spacing='24px'>
          <a
            className="hover:opacity-50 transition duration-500"
            href="https://x.com/kascadexyz"
            target="_blank"
            rel="noreferrer"
          >
            <img alt="twitter-link" src="../assets/twitter.png" />
          </a>
          <a
            className="hover:opacity-50 transition duration-500"
            href="https://t.me/+jCJWkBo0SVE1MzQx"
            target="_blank"
            rel="noreferrer"
          >
            <img alt="telegram-link" src="../assets/telegramIconWhite.png" />
          </a>
          
          
        </HStack>  
      </Flex>

      

      
    </div>

  );
};

export default SocialMediaIcons;
